import type {ReactElement} from 'react';
import {useState} from 'react';
import React from 'react';
import type {InputSuggestionsDropdownProps} from '@Components/input-suggestions-dropdown/input-suggestions-dropdown.types';
import type {InputFieldProps} from '@Components/input-field-v2';
import {InputField} from '@Components/input-field-v2';
import {InputSuggestionsDropdown} from '@Components/input-suggestions-dropdown/input-suggestions-dropdown';
import type {InputType} from '@Components/input-field-v2/input-field.types';

export interface EmailMakerInputSuggestionsDropdownProps {
  inputId: string;
  dropdownId: string;
  inputSuggestionsDropdownProps?: Partial<InputSuggestionsDropdownProps>;
  inputFieldProps?: Partial<InputFieldProps>;
}

export function EmailMakerInputSuggestionsDropdown({...props}: EmailMakerInputSuggestionsDropdownProps): ReactElement {
  const [inputValue, setInputValue] = useState<InputType>(props.inputFieldProps?.input ?? '');

  const handleSuggestionSelect = (inputValue: string): void => {
    setInputValue(inputValue);
    props.inputSuggestionsDropdownProps?.onSuggestionSelect?.(inputValue);
  }

  const getInputSelector = (): ReactElement => {
    return (
      <InputField
        id={props.inputId}
        input={inputValue}
        placeholder={props.inputFieldProps?.placeholder}
        size={props.inputFieldProps?.size}
        inputClassName={props.inputFieldProps?.inputClassName}
        onInputFocus={props.inputFieldProps?.onInputFocus}
        onInputBlur={props.inputFieldProps?.onInputBlur}
        onInputChange={setInputValue}
      />
    );
  };

  return (
    <InputSuggestionsDropdown
      inputValue={String(inputValue)}
      inputSelector={getInputSelector()}
      onSuggestionSelect={handleSuggestionSelect}
      dropdownId={props.dropdownId}
      popupAlignment={props.inputSuggestionsDropdownProps?.popupAlignment}
      truncateText={props.inputSuggestionsDropdownProps?.truncateText}
      popupPosition={props.inputSuggestionsDropdownProps?.popupPosition}
      popupClassName={props.inputSuggestionsDropdownProps?.popupClassName}
      primarySuggestionsList={props.inputSuggestionsDropdownProps?.primarySuggestionsList}
      recentSuggestionsList={props.inputSuggestionsDropdownProps?.recentSuggestionsList}
      miscSuggestionsList={props.inputSuggestionsDropdownProps?.miscSuggestionsList}
      showSuggestionAsTitleOnHover={props.inputSuggestionsDropdownProps?.showSuggestionAsTitleOnHover}
    />
  );
}
